'use strict';

const login = require('../../login');
const gtm = require('../../modules/google').tagManager;

const init = function () {
    login.init();

    gtm.bindFormFieldErrorEvents();
};

exports.init = init;
